import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/login/login";
import Dashboard from "./pages/dashboard/Dashboard";

import ProtectedRoute from "./component/ProtectedRoute";
import DashboardLayout from "./component/layout/DashboardLayout";
import Users from "./pages/users/Users";
import MonthlyReports from "./pages/reports/Monthly/MonthlyReport";
import Settings from "./pages/settings/Settings";
import { useAuth } from "./context/AuthContext";

import QuartlyReport from "./pages/reports/quarterly/QuartlyReport";
import ConsigneeList from "./pages/reports/General/ConsigneeList";
import RateList from "./pages/reports/General/RateList";
import AllocationList from "./pages/reports/General/AllocationList";

import ReportViewer from "./pages/reports/General/ReportViewer";
import ConsigneeEntry from "./pages/entry/consignee/ConsigneeEntry";
import AllocatioHeadEntry from "./pages/entry/allocationhead/AllocationHead";
import Allocation from "./pages/entry/allocation/Allocation";
import TimeOffice from "./pages/entry/timeOffice/TimeOffice";
import EGAENGA from "./pages/entry/EgaSection/EgaSection.jsx"
import INSENTIVE from "./pages/entry/accountOffice/AccountOffice.jsx"
import IOH from "./pages/entry/ioh/IOHDataEntry.jsx";
import POHDataEntry from "./pages/entry/poh/POHDataEntry.jsx";
import WLSDataEntry from "./pages/entry/wls/WLSDataEntry.jsx";
import CreditJVDataEntry from "./pages/entry/creidtjv/CreditJVDataEntry.jsx";
import FreightAndProformaOnCostDataEntry from "./pages/entry/freightAndProformaOnCost/FreightAndProformaOnCostDataEntry.jsx";
import LabourRateUpdate from "./pages/entry/labourrate/LabourRateUpdate.jsx";
import POHOuttern from "./pages/entry/pohouttern/POHOuttern.jsx";
 import IMMISDataImport from "./pages/entry/iMMIS/IMMISDataImport.jsx";
import IMMISDataProcess from "./pages/entry/dataProcess/IMMISDataProcess.jsx";
import DataFinalised from "./pages/entry/datafinalised/dataFinalised.js";
import UserProfile from "./pages//userprofile/UserProfile.jsx";
import UserManagement from "./pages/userManagement/UserManagement.jsx"



export default function App() {
  const { token } = useAuth();

  return (
    <Routes>
      {/* Login */}
      <Route
        path="/login"
        element={
          token ? <Navigate to="/" replace /> : <Login />
        }
      />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute>  <DashboardLayout /> </ProtectedRoute>} >


        {/* Dashboard */}
        <Route index element={<Dashboard />} />

        {/* User Page */}
        <Route path="users" element={<Users />} />

        {/* Reports */}
        <Route path="/reports/monthly" element={<MonthlyReports />} />
        <Route path="/reports/quarterly" element={<QuartlyReport />} />
        <Route path="/reports/consigneelist" element={<ConsigneeList />} />
        <Route path="/reports/ratelist" element={<RateList />} />
        <Route path="/reports/allocationlist" element={<AllocationList />} />
        <Route path="/reports/:id" element={<ReportViewer />} />


        {/* Master Entries */}
        <Route path="/masterentry/consignee" element={<ConsigneeEntry />} />
        <Route path="masterentry/allocationhead" element={<AllocatioHeadEntry />} />
        <Route path="/masterentry/allocation" element={<Allocation />} />
        <Route path="/entry/timeofficedata" element={<TimeOffice />} />
        <Route path="/entry/egaenga" element={<EGAENGA /> } />
        <Route path="/entry/insentive" element={<INSENTIVE /> } />
        <Route path="/entry/ioh" element={<IOH /> } />
         <Route path="/entry/poh" element={<POHDataEntry /> } />
         <Route path="/entry/wls" element={<WLSDataEntry /> } />
          <Route path="/entry/creditjv" element={<CreditJVDataEntry /> } />
          <Route path="/entry/proforma" element={<FreightAndProformaOnCostDataEntry /> } />
 <Route path="/entry/updatelabourrate" element={<LabourRateUpdate /> } />
<Route path="/entry/pohoutturn" element={<POHOuttern /> } />
<Route path="/import" element={<IMMISDataImport /> } />
<Route path="/masterentry/monthly-data" element={<IMMISDataProcess /> } />
<Route path="/masterentry/finalised-data" element={<DataFinalised /> } />
<Route path="/profile"  element={<UserProfile />} />

<Route path="/setting/usermanagement"  element={<UserManagement />}/>

        {/* Settings */}
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Unknown Route */}
      <Route path="*" element={<Navigate to={token ? "/" : "/login"} replace />} />
    </Routes>
  );
}